import React, { useState } from 'react';
import { ArrowLeft, Bell } from 'lucide-react';

const ActivationMethode = () => {
  const [methodesActives, setMethodesActives] = useState({
    fedapay: true,
    kkiapay: false
  });

  const toggleMethode = (methode) => {
    setMethodesActives(prev => ({
      ...prev,
      [methode]: !prev[methode]
    }));
  };

  return (
    <div className="min-h-screen bg-purple-50">
      {/* Header */}
      <header className="bg-white px-4 py-3 flex items-center justify-between shadow-sm">
        <div className="flex items-center space-x-4">
          <ArrowLeft className="w-6 h-6 text-blue-600" />
          <h1 className="text-blue-600 text-lg font-medium">Kappela Vendeur</h1>
        </div>
        <Bell className="w-6 h-6 text-gray-700" />
      </header>

      {/* Main Content */}
      <main className="px-4 py-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Activation</h2>
        <p className="text-gray-600 mb-8">
          Activer vos méthodes de paiement ici et en un clic simplement et facilement.
        </p>

        {/* Méthodes actives */}
        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Mes méthodes actives
            </h3>
            <div className="bg-white rounded-2xl p-4 flex items-center justify-between shadow-sm">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8">
                  <img src="/api/placeholder/32/32" alt="FedaPay" className="w-full h-full object-contain" />
                </div>
                <span className="font-medium text-gray-800">FedaPay</span>
              </div>
              <button
                onClick={() => toggleMethode('fedapay')}
                className={`w-12 h-6 rounded-full p-1 transition-colors duration-200 ease-in-out ${
                  methodesActives.fedapay ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <div
                  className={`w-4 h-4 rounded-full bg-white transition-transform duration-200 ease-in-out ${
                    methodesActives.fedapay ? 'translate-x-6' : 'translate-x-0'
                  }`}
                />
              </button>
            </div>
          </div>

          {/* Méthodes inactives */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Mes méthodes inactives
            </h3>
            <div className="bg-white rounded-2xl p-4 flex items-center justify-between shadow-sm">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8">
                  <img src="/api/placeholder/32/32" alt="KkiaPay" className="w-full h-full object-contain" />
                </div>
                <span className="font-medium text-gray-800">KkiaPay</span>
              </div>
              <button
                onClick={() => toggleMethode('kkiapay')}
                className={`w-12 h-6 rounded-full p-1 transition-colors duration-200 ease-in-out ${
                  methodesActives.kkiapay ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <div
                  className={`w-4 h-4 rounded-full bg-white transition-transform duration-200 ease-in-out ${
                    methodesActives.kkiapay ? 'translate-x-6' : 'translate-x-0'
                  }`}
                />
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ActivationMethode;